// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/components/CompartmentVisualization3D/CompartmentVisualization3D.css */

/* ============================================
   3D COMPARTMENT VISUALIZATION
   ============================================ */

.compartment-viz-3d {
  width: 100%;
  aspect-ratio: 16 / 10;
  max-height: 150px;
  position: relative;
  overflow: hidden;
  border-radius: var(--radius-lg);
  background: linear-gradient(
    180deg,
    #f5efe6 0%,
    #ede4d6 40%,
    #e0d3c0 100%
  );
  box-shadow:
    0 4px 12px rgba(92, 58, 30, 0.2),
    inset 0 1px 2px rgba(255, 255, 255, 0.4);
  -webkit-user-select: none;
  user-select: none;
  touch-action: none;
}

/* ---- Piles Area ---- */
.compartment-viz-3d__piles-area {
  position: absolute;
  top: 0;
  left: 3%;
  right: 3%;
  bottom: 0%;
  z-index: 1;
}

/* ---- Individual Pile Positioning ---- */
.compartment-viz-3d__pile-position {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

/* ---- Ground shadow under each pile ---- */
.compartment-viz-3d__pile-shadow {
  position: absolute;
  bottom: -2px;
  left: -5%;
  right: -10%;
  height: 5px;
  background: radial-gradient(
    ellipse at 45% 50%,
    rgba(60, 35, 10, 0.35) 0%,
    rgba(60, 35, 10, 0.1) 55%,
    transparent 80%
  );
  border-radius: 50%;
  z-index: 0;
}

/* ---- 3D Pile Block ---- */
.compartment-viz-3d__pile {
  width: 100%;
  position: relative;
  height: var(--pile-height, 6px);
  will-change: height;
}

/* ---- Front Face ---- */
.compartment-viz-3d__pile-front {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 3px 3px 1px 1px;
  box-shadow:
    0 2px 6px rgba(0, 0, 0, 0.14),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  overflow: hidden;
}

/* ---- Top Face ---- */
.compartment-viz-3d__pile-top {
  position: absolute;
  top: -7px;
  left: 0;
  width: 100%;
  height: 10px;
  border-radius: 3px 3px 0 0;
  transform: skewX(-20deg) scaleY(0.7);
  transform-origin: bottom left;
  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.25);
}

/* ---- Right Side Face ---- */
.compartment-viz-3d__pile-side {
  position: absolute;
  bottom: 0;
  right: -6px;
  width: 7px;
  height: 100%;
  border-radius: 0 3px 3px 0;
  transform: skewY(-14deg);
  transform-origin: top left;
}

/* ---- Card texture lines ---- */
.compartment-viz-3d__pile-lines {
  position: absolute;
  bottom: 2px;
  left: 10%;
  right: 10%;
  top: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  overflow: hidden;
}

.compartment-viz-3d__pile-line {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 1px;
}

/* ---- Pile Label ---- */
.compartment-viz-3d__pile-label {
  margin-top: 2px;
  font-weight: var(--font-weight-bold);
  color: var(--color-wood-dark);
  text-align: center;
  line-height: 1;
  letter-spacing: 0.3px;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
  z-index: 3;
}

/* ============================================
   COMPARTMENT COLORS
   ============================================ */

/* Fach 1 — Red */
.compartment-viz-3d__pile--1 .compartment-viz-3d__pile-front {
  background: linear-gradient(180deg, #ef5350 0%, #e53935 55%, #c62828 100%);
}
.compartment-viz-3d__pile--1 .compartment-viz-3d__pile-top {
  background: linear-gradient(135deg, #ef9a9a 0%, #ef5350 100%);
}
.compartment-viz-3d__pile--1 .compartment-viz-3d__pile-side {
  background: linear-gradient(180deg, #c62828 0%, #b71c1c 100%);
}

/* Fach 2 — Orange */
.compartment-viz-3d__pile--2 .compartment-viz-3d__pile-front {
  background: linear-gradient(180deg, #ffa726 0%, #ff8f00 55%, #e65100 100%);
}
.compartment-viz-3d__pile--2 .compartment-viz-3d__pile-top {
  background: linear-gradient(135deg, #ffcc80 0%, #ffa726 100%);
}
.compartment-viz-3d__pile--2 .compartment-viz-3d__pile-side {
  background: linear-gradient(180deg, #e65100 0%, #bf360c 100%);
}

/* Fach 3 — Yellow */
.compartment-viz-3d__pile--3 .compartment-viz-3d__pile-front {
  background: linear-gradient(180deg, #fdd835 0%, #f9a825 55%, #f57f17 100%);
}
.compartment-viz-3d__pile--3 .compartment-viz-3d__pile-top {
  background: linear-gradient(135deg, #fff59d 0%, #fdd835 100%);
}
.compartment-viz-3d__pile--3 .compartment-viz-3d__pile-side {
  background: linear-gradient(180deg, #f57f17 0%, #e65100 100%);
}

/* Fach 4 — Green */
.compartment-viz-3d__pile--4 .compartment-viz-3d__pile-front {
  background: linear-gradient(180deg, #66bb6a 0%, #43a047 55%, #2e7d32 100%);
}
.compartment-viz-3d__pile--4 .compartment-viz-3d__pile-top {
  background: linear-gradient(135deg, #a5d6a7 0%, #66bb6a 100%);
}
.compartment-viz-3d__pile--4 .compartment-viz-3d__pile-side {
  background: linear-gradient(180deg, #2e7d32 0%, #1b5e20 100%);
}

/* Fach 5 — Blue */
.compartment-viz-3d__pile--5 .compartment-viz-3d__pile-front {
  background: linear-gradient(180deg, #42a5f5 0%, #1e88e5 55%, #1565c0 100%);
}
.compartment-viz-3d__pile--5 .compartment-viz-3d__pile-top {
  background: linear-gradient(135deg, #90caf9 0%, #42a5f5 100%);
}
.compartment-viz-3d__pile--5 .compartment-viz-3d__pile-side {
  background: linear-gradient(180deg, #1565c0 0%, #0d47a1 100%);
}

/* ---- Empty pile state ---- */
.compartment-viz-3d__pile--empty .compartment-viz-3d__pile-front {
  opacity: 0.25;
}
.compartment-viz-3d__pile--empty .compartment-viz-3d__pile-top {
  opacity: 0.15;
}
.compartment-viz-3d__pile--empty .compartment-viz-3d__pile-side {
  opacity: 0.15;
}

/* ---- Empty State Hint ---- */
.compartment-viz-3d__empty-hint {
  position: absolute;
  bottom: 14%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(92, 58, 30, 0.88);
  color: var(--color-text-on-wood);
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--radius-md);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  white-space: nowrap;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 10;
  animation: hint-pulse 2s ease-in-out infinite;
}

@keyframes hint-pulse {
  0%, 100% { opacity: 0.9; }
  50% { opacity: 1; }
}

/* ---- Non-interactive ---- */
.compartment-viz-3d,
.compartment-viz-3d * {
  pointer-events: none;
}

/* ---- Responsive ---- */
@media (max-width: 360px) {
  .compartment-viz-3d {
    aspect-ratio: 16 / 9;
    max-height: 90px;
  }
}

@media (min-width: 481px) {
  .compartment-viz-3d {
    max-height: 140px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CompartmentVisualization3D/CompartmentVisualization3D.css"],"names":[],"mappings":"AAAA,kIAAkI;;AAElI;;iDAEiD;;AAEjD;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B;;;;;GAKC;EACD;;4CAE0C;EAC1C,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,WAAW;EACX;;;;;GAKC;EACD,kBAAkB;EAClB,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B;;0CAEwC;EACxC,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;;iDAEiD;;AAEjD,iBAAiB;AACjB;EACE,0EAA0E;AAC5E;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;;AAEA,oBAAoB;AACpB;EACE,0EAA0E;AAC5E;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;;AAEA,oBAAoB;AACpB;EACE,0EAA0E;AAC5E;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;;AAEA,mBAAmB;AACnB;EACE,0EAA0E;AAC5E;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;;AAEA,kBAAkB;AAClB;EACE,0EAA0E;AAC5E;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,wCAAwC;EACxC,gCAAgC;EAChC,wCAAwC;EACxC,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA,8BAA8B;AAC9B;;EAEE,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE;IACE,oBAAoB;IACpB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/components/CompartmentVisualization3D/CompartmentVisualization3D.css */\n\n/* ============================================\n   3D COMPARTMENT VISUALIZATION\n   ============================================ */\n\n.compartment-viz-3d {\n  width: 100%;\n  aspect-ratio: 16 / 10;\n  max-height: 150px;\n  position: relative;\n  overflow: hidden;\n  border-radius: var(--radius-lg);\n  background: linear-gradient(\n    180deg,\n    #f5efe6 0%,\n    #ede4d6 40%,\n    #e0d3c0 100%\n  );\n  box-shadow:\n    0 4px 12px rgba(92, 58, 30, 0.2),\n    inset 0 1px 2px rgba(255, 255, 255, 0.4);\n  -webkit-user-select: none;\n  user-select: none;\n  touch-action: none;\n}\n\n/* ---- Piles Area ---- */\n.compartment-viz-3d__piles-area {\n  position: absolute;\n  top: 0;\n  left: 3%;\n  right: 3%;\n  bottom: 0%;\n  z-index: 1;\n}\n\n/* ---- Individual Pile Positioning ---- */\n.compartment-viz-3d__pile-position {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n/* ---- Ground shadow under each pile ---- */\n.compartment-viz-3d__pile-shadow {\n  position: absolute;\n  bottom: -2px;\n  left: -5%;\n  right: -10%;\n  height: 5px;\n  background: radial-gradient(\n    ellipse at 45% 50%,\n    rgba(60, 35, 10, 0.35) 0%,\n    rgba(60, 35, 10, 0.1) 55%,\n    transparent 80%\n  );\n  border-radius: 50%;\n  z-index: 0;\n}\n\n/* ---- 3D Pile Block ---- */\n.compartment-viz-3d__pile {\n  width: 100%;\n  position: relative;\n  height: var(--pile-height, 6px);\n  will-change: height;\n}\n\n/* ---- Front Face ---- */\n.compartment-viz-3d__pile-front {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 3px 3px 1px 1px;\n  box-shadow:\n    0 2px 6px rgba(0, 0, 0, 0.14),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n  overflow: hidden;\n}\n\n/* ---- Top Face ---- */\n.compartment-viz-3d__pile-top {\n  position: absolute;\n  top: -7px;\n  left: 0;\n  width: 100%;\n  height: 10px;\n  border-radius: 3px 3px 0 0;\n  transform: skewX(-20deg) scaleY(0.7);\n  transform-origin: bottom left;\n  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.25);\n}\n\n/* ---- Right Side Face ---- */\n.compartment-viz-3d__pile-side {\n  position: absolute;\n  bottom: 0;\n  right: -6px;\n  width: 7px;\n  height: 100%;\n  border-radius: 0 3px 3px 0;\n  transform: skewY(-14deg);\n  transform-origin: top left;\n}\n\n/* ---- Card texture lines ---- */\n.compartment-viz-3d__pile-lines {\n  position: absolute;\n  bottom: 2px;\n  left: 10%;\n  right: 10%;\n  top: 4px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  overflow: hidden;\n}\n\n.compartment-viz-3d__pile-line {\n  width: 100%;\n  height: 1px;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 1px;\n}\n\n/* ---- Pile Label ---- */\n.compartment-viz-3d__pile-label {\n  margin-top: 2px;\n  font-weight: var(--font-weight-bold);\n  color: var(--color-wood-dark);\n  text-align: center;\n  line-height: 1;\n  letter-spacing: 0.3px;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n  z-index: 3;\n}\n\n/* ============================================\n   COMPARTMENT COLORS\n   ============================================ */\n\n/* Fach 1 — Red */\n.compartment-viz-3d__pile--1 .compartment-viz-3d__pile-front {\n  background: linear-gradient(180deg, #ef5350 0%, #e53935 55%, #c62828 100%);\n}\n.compartment-viz-3d__pile--1 .compartment-viz-3d__pile-top {\n  background: linear-gradient(135deg, #ef9a9a 0%, #ef5350 100%);\n}\n.compartment-viz-3d__pile--1 .compartment-viz-3d__pile-side {\n  background: linear-gradient(180deg, #c62828 0%, #b71c1c 100%);\n}\n\n/* Fach 2 — Orange */\n.compartment-viz-3d__pile--2 .compartment-viz-3d__pile-front {\n  background: linear-gradient(180deg, #ffa726 0%, #ff8f00 55%, #e65100 100%);\n}\n.compartment-viz-3d__pile--2 .compartment-viz-3d__pile-top {\n  background: linear-gradient(135deg, #ffcc80 0%, #ffa726 100%);\n}\n.compartment-viz-3d__pile--2 .compartment-viz-3d__pile-side {\n  background: linear-gradient(180deg, #e65100 0%, #bf360c 100%);\n}\n\n/* Fach 3 — Yellow */\n.compartment-viz-3d__pile--3 .compartment-viz-3d__pile-front {\n  background: linear-gradient(180deg, #fdd835 0%, #f9a825 55%, #f57f17 100%);\n}\n.compartment-viz-3d__pile--3 .compartment-viz-3d__pile-top {\n  background: linear-gradient(135deg, #fff59d 0%, #fdd835 100%);\n}\n.compartment-viz-3d__pile--3 .compartment-viz-3d__pile-side {\n  background: linear-gradient(180deg, #f57f17 0%, #e65100 100%);\n}\n\n/* Fach 4 — Green */\n.compartment-viz-3d__pile--4 .compartment-viz-3d__pile-front {\n  background: linear-gradient(180deg, #66bb6a 0%, #43a047 55%, #2e7d32 100%);\n}\n.compartment-viz-3d__pile--4 .compartment-viz-3d__pile-top {\n  background: linear-gradient(135deg, #a5d6a7 0%, #66bb6a 100%);\n}\n.compartment-viz-3d__pile--4 .compartment-viz-3d__pile-side {\n  background: linear-gradient(180deg, #2e7d32 0%, #1b5e20 100%);\n}\n\n/* Fach 5 — Blue */\n.compartment-viz-3d__pile--5 .compartment-viz-3d__pile-front {\n  background: linear-gradient(180deg, #42a5f5 0%, #1e88e5 55%, #1565c0 100%);\n}\n.compartment-viz-3d__pile--5 .compartment-viz-3d__pile-top {\n  background: linear-gradient(135deg, #90caf9 0%, #42a5f5 100%);\n}\n.compartment-viz-3d__pile--5 .compartment-viz-3d__pile-side {\n  background: linear-gradient(180deg, #1565c0 0%, #0d47a1 100%);\n}\n\n/* ---- Empty pile state ---- */\n.compartment-viz-3d__pile--empty .compartment-viz-3d__pile-front {\n  opacity: 0.25;\n}\n.compartment-viz-3d__pile--empty .compartment-viz-3d__pile-top {\n  opacity: 0.15;\n}\n.compartment-viz-3d__pile--empty .compartment-viz-3d__pile-side {\n  opacity: 0.15;\n}\n\n/* ---- Empty State Hint ---- */\n.compartment-viz-3d__empty-hint {\n  position: absolute;\n  bottom: 14%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: rgba(92, 58, 30, 0.88);\n  color: var(--color-text-on-wood);\n  padding: var(--space-xs) var(--space-sm);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  white-space: nowrap;\n  text-align: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 10;\n  animation: hint-pulse 2s ease-in-out infinite;\n}\n\n@keyframes hint-pulse {\n  0%, 100% { opacity: 0.9; }\n  50% { opacity: 1; }\n}\n\n/* ---- Non-interactive ---- */\n.compartment-viz-3d,\n.compartment-viz-3d * {\n  pointer-events: none;\n}\n\n/* ---- Responsive ---- */\n@media (max-width: 360px) {\n  .compartment-viz-3d {\n    aspect-ratio: 16 / 9;\n    max-height: 90px;\n  }\n}\n\n@media (min-width: 481px) {\n  .compartment-viz-3d {\n    max-height: 140px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
